import { render, staticRenderFns } from "./LiveScorer.vue?vue&type=template&id=c8d646da&"
import script from "./LiveScorer.vue?vue&type=script&lang=js&"
export * from "./LiveScorer.vue?vue&type=script&lang=js&"
import style0 from "./LiveScorer.vue?vue&type=style&index=0&id=c8d646da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports